
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mint/apepe-loot/[pieceId]",
      function () {
        return require("private-next-pages/mint/apepe-loot/[pieceId].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mint/apepe-loot/[pieceId]"])
      });
    }
  